export const getUrl = (path, options) => {
  const {
    hubletOriginOverride
  } = options || {};

  if (!hubletOriginOverride) {
    return path;
  }

  const originOverride = hubletOriginOverride.replace(/\/$/, '');
  return `${originOverride}/${path.replace(/^\//, '')}`;
};